import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Package, Truck } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const LandingCTA = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  const handleGetStarted = (userType: 'customer' | 'carrier') => {
    navigate(`/auth?userType=${userType}`);
  };

  return (
    <section className="py-20 px-4 bg-gradient-to-br from-muted/30 to-background">
      <div className="container mx-auto max-w-4xl text-center animate-fade-in">
        <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6">{t('landing.cta.title')}</h2>
        <p className="text-xl text-muted-foreground mb-12">
          {t('landing.cta.subtitle')}
        </p>
        
        <div className="flex justify-center">
          <Button size="lg" onClick={() => handleGetStarted('customer')} className="text-lg px-10 py-6 hover-scale bg-gradient-to-r from-[hsl(171,78%,60%)] to-[hsl(195,85%,56%)] hover:from-[hsl(171,78%,55%)] hover:to-[hsl(195,85%,51%)] text-white border-0">
            <Package className="mr-2 h-5 w-5" />
            {t('landing.cta.button')}
          </Button>
        </div>
      </div>
    </section>
  );
};